var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'thumbnail-only': _vm.thumbnailOnly }},[_c('input',{ref:_vm.inputId,staticClass:"pr-8 focus:border-blue-300 focus:shadow-outline-blue",class:[
            _vm.thumbnailOnly
                ? 'h-7 w-7 cursor-pointer rounded-lg border-0 bg-transparent p-0 text-transparent'
                : 'w-full rounded-md border-gray-300 py-1 text-sm text-gray-900 shadow-sm transition duration-150 ease-in-out'
        ],attrs:{"id":_vm.inputId,"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }